/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Dialog, { DialogTitle } from 'material-ui/Dialog';
import Typography from 'material-ui/Typography';
import { Button, DialogActions, DialogContent, MenuItem, Paper, TextField } from 'material-ui';
import Room from './Room';
import { translate } from 'react-i18next';

const styles = {
    avatar: {
        backgroundColor: 'dark-grey',
        color: 'grey',
    },
    root: {
        backgroundColor: 'var(--primary-color)',
        color: 'var(--primary-text-color)'
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    roomNumberTextField: {
        width: '140px',
        marginBottom: '32px',
    },
    footNoteText: {
        marginTop: '16px',
        fontWeight: 300,
        paddingTop: 0
    },
    dialogTitle: {
        fontWeight: '300',
        fontSize: '24px'
    }
};
/**
 * Componente encargado de la edicion de huespedes y habitaciones.
 * Maneja una copia del rooms original. Si cancela no devuelve el rooms, Si Acepta devuelve el rooms actualizado.
 *
 * @author Luciano Bustos
 *
 */
class SearchOptionsDialog extends React.Component {
    state = {
        totalRooms: 1,
        rooms: [
            {
                adults: 2,
                kids: [],
            },
        ],
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.rooms) {
            let state = this.state;
            state.rooms = nextProps.rooms;
            this.setState(state);
        }
        if (nextProps && nextProps.totalRooms) {
            let state = this.state;
            state.totalRooms = nextProps.totalRooms;
            this.setState(state);
        }
    }

    handleClose = () => {
        this.showBodyScrollBars();
        this.props.onClose(this.state);
    };

    handleCancel = () => {
        this.showBodyScrollBars();
        this.props.onClose(null);
    };

    showBodyScrollBars = () => {
        // dialog has side-effect that prevents body from scrolling if this not checked
        //document.querySelector('body').style.overflow = 'visible';
    };

    handleEnter = () => {
        this.hideBodyScrollBars();
    };

    hideBodyScrollBars() {
        // dialog has a side-effect if this not checked
        document.querySelector('body').style.overflow = 'hidden';
    }

    handleTotalRoomChange = event => {
        let totalRooms = event.target.value;
        if (totalRooms > this.state.totalRooms) {
            let dif = totalRooms - this.state.totalRooms;
            let plusRooms = Array.from(Array(dif), x => ({
                adults: 2,
                kids: [],
                mealPlan: 'ALL',
            }));
            let rooms = this.state.rooms.concat(plusRooms);
            this.setState({ totalRooms, rooms });
        } else if (totalRooms < this.state.totalRooms) {
            let rooms = this.state.rooms.slice(0, totalRooms);
            this.setState({ totalRooms, rooms });
        }
    };

    handleAdultChange = (number, adults) => {
        let rooms = this.state.rooms;
        rooms[number].adults = adults;
        this.setState({ rooms });
    };

    handleKidsChange = (number, kids) => {
        let rooms = this.state.rooms;
        rooms[number].kids = Array.from(Array(kids), x => ({ age: 0 }));
        this.setState({ rooms });
    };

    handleKidsAgeChange = (number, numberKid, age) => {
        let rooms = this.state.rooms;
        rooms[number].kids[numberKid].age = age;
        this.setState({ rooms });
    };


    render() {
        const { classes, onClose, t, ...other } = this.props;
        let { rooms } = this.state;
        const roomsValues = Array.from(Array(6).keys());
        roomsValues.shift();
        return (
            <Dialog
                onClose={this.handleClose}
                onEnter={this.handleEnter}
                aria-labelledby="simple-dialog-title"
                PaperProps={{
                    classes: {
                        root: classes.root
                    }
                }
                }
                {...other}>
                <DialogTitle disableTypography={true} id="simple-dialog-title" className={classes.dialogTitle}>
                    {t('HOME.MODIFY_ROOMS_PASSENGERS')}
                </DialogTitle>
                <DialogContent>
                    <Paper style={{ backgroundColor: 'transparent', minWidth: '480px', padding: '12px' }} elevation={0}>
                        <TextField
                            select
                            label={t('HOME.ROOMS_QUANTITY')}
                            name={'totalRooms'}
                            className="cmsFormContainer"
                            fullWidth
                            value={this.state.totalRooms}
                            onChange={this.handleTotalRoomChange}
                            SelectProps={{ MenuProps: { className: classes.menu } }}
                            InputLabelProps={{
                                className: classes.inputLabel,
                            }}>
                            {roomsValues.map(option => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                        {rooms.map((r, number) => (
                            <Room
                                classes
                                key={number}
                                number={number}
                                {...r}
                                handleAdultChange={this.handleAdultChange}
                                handleKidsChange={this.handleKidsChange}
                                handleKidsAgeChange={this.handleKidsAgeChange}
                            />
                        ))}
                        <Typography
                            className={classes.footNoteText}
                            variant={'caption'}>
                            {t('HOME.BABIES_AS_CHILDREN')}
                        </Typography>
                    </Paper>
                </DialogContent>
                <DialogActions style={{ padding: '12px' }}>
                    <Button onClick={this.handleCancel}>{t('COMMON.CANCEL')}</Button>
                    <Button onClick={this.handleClose} color="primary" variant="raised">
                        {t('COMMON.CONFIRM')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

SearchOptionsDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func,
};

export default translate('translations')(withStyles(styles)(SearchOptionsDialog));



// WEBPACK FOOTER //
// ./src/components/SearchContent/SearchOptionsDialog.js